import { Response, User } from "@/types";
import axios from "./axios";

export const login = async ({ tenant, email = "", username = "", password, session, code }) => {
  const result = (await axios.post(
    "/api/v1/um/login",
    session ? { session, code } : { tenant, email, username, password },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    },
  )) as Response<string>;
  if (!result) {
    return { status: "error", error: { message: "No response from server" } };
  } else if (result.status === "ok" || result.status === "OK") {
    return { token: result.value };
  } else {
    return result;
  }
};

export const logout = async () => {
  return await axios.post("/api/v1/um/logout");
};

export const getCurrentUser = async () => {
  const result = (await axios.get("/api/v1/um/me")) as Response<User>;
  if (!result) {
    return null;
  } else if (result.status === "ok" || result.status === "OK") {
    return result.value;
  } else {
    return null;
  }
};

export const register = async ({ tenantname, email, username, password }) => {
  try {
    const tdata: any = await axios.post(
      "/api/v1/um/signup",
      {
        username,
        tenantname,
        password,
        email,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    if (tdata.status === "Error" || tdata.status === "error") {
      return { status: "error", error: { message: tdata.value } };
    }
    return tdata;
  } catch (error) {
    return { status: "error", error };
  }
};

export const setup = async ({ tenant, email, user, password, instance, domain_prefix, token }) => {
  try {
    const tdata: any = await axios.post(
      "/api/v1/marketing/setup",
      {
        user,
        tenant,
        password,
        email,
        instance,
        domain_prefix,
        token
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    if (tdata.status === "Error" || tdata.status === "error") {
      return { status: "error", error: { message: tdata.message } };
    }
    return tdata;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updatePassword = async ({ oldpassword, newpassword }) => {
  try {
    const data: any = await axios.put(
      "/api/v1/um/me?op=changepassword",
      {
        oldpassword,
        newpassword,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    if (data.status === "Error" || data.status === "error") {
      return { status: "error", error: { message: data.value } };
    }
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateProperty = async (meta) => {
  try {
    const data: any = await axios.put(
      "/api/v1/um/me?op=changeproperty",
      meta,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    if (data.status === "Error" || data.status === "error") {
      return { status: "error", error: { message: data.value } };
    }
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getTenantMFAInfoByCurrentUser = async () => {
  const result: any = (await axios.get("/api/v1/um/me/cognito/tenantmfa"));
  if (!result) {
    return null;
  } else if (result.status === "ok" || result.status === "OK") {
    return result.value;
  } else {
    return null;
  }
};

export const getMFAByCurrentUser = async () => {
  const result: any = (await axios.get("/api/v1/um/me/cognito/mfa"));
  if (!result) {
    return null;
  } else if (result.status === "ok" || result.status === "OK") {
    return result.value;
  } else {
    return null;
  }
};

export const updateMFAByCurrentUser = async ({email_mfa, sms_mfa, app_mfa, preferred_mfa}) => {
  const result: any = await axios.put("/api/v1/um/me/cognito/mfa",{
    email_mfa,
    sms_mfa,
    app_mfa,
    preferred_mfa
  },{
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  return result;
};

export const getSoftwareToken = async () => {
  const result: any = (await axios.get("/api/v1/um/me/cognito/softwaretoken"));
  if (!result) {
    return null;
  } else if (result.status === "ok" || result.status === "OK") {
    return result.value;
  } else {
    return null;
  }
}

export const setupSoftwareToken = async ({code}) => {
  const result: any = (await axios.put("/api/v1/um/me/cognito/softwaretoken", {code},{
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  }));
  return result;
}
